import {useEffect, useRef, useState} from 'react';
import QuestionItem from './QuestionItem';
import {View} from "../../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import {ThemeButton} from "../../../../custom-packages/react-button-package/ButtonPackage";
import AppConfig from "../../../../AppConfig";
import PollQuestion from "../../../../models/poll/PollQuestion"; // This will be another component you will define
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';

const TQuestionList = {
    // English
    "enUS": {
        'NEW_QUESTION': 'New Question',
    },
    // Spanish
    "esMX": {
        'NEW_QUESTION': 'Nueva Pregunta',
    }
}

const QuestionList = ({initialQuestions, onListChange}) => {
    const [questions, setQuestions] = useState<Array<PollQuestion>>(initialQuestions);
    const isFirstRender = useRef(true);

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;

        const updatedItems = Array.from(questions);
        const [movedItem] = updatedItems.splice(result.source.index, 1);
        updatedItems.splice(result.destination.index, 0, movedItem);

        // Update the pqu_order of each item based on its new position
        updatedItems.forEach((item, index) => {
            item.pqu_order = index + 1; // Assuming pqu_order is 1-based
        });

        setQuestions(updatedItems);
    };

    const addQuestion = () => {
        const questionsCopy = [...questions];
        const newQuestion = new PollQuestion();

        newQuestion.pqu_order = questions.length + 1;

        questionsCopy.push(newQuestion);
        setQuestions(questionsCopy);
    };

    const updateQuestion = (index, question) => {
        const newQuestions = [...questions];
        newQuestions[index] = question;
        setQuestions(newQuestions);
    };

    const removeQuestion = (index) => {
        const newQuestions = [...questions];

        if (newQuestions[index].pqu_id)
            newQuestions[index].removed = true
        else
            newQuestions.splice(index, 1);

        setQuestions(newQuestions);
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        onListChange([...questions]);
    }, [questions]);

    return (
        <View>
            <View>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="droppable-list">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {questions.map((question, index) => (
                                    <Draggable
                                        key={question.pqu_id ? question.pqu_id : question.local_id}
                                        draggableId={question.pqu_id ? question.pqu_id : question.local_id}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <QuestionItem
                                                    question={question}
                                                    onQuestionChange={(q) => updateQuestion(index, q)}
                                                    onRemove={() => removeQuestion(index)}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </View>
            <View
                className={'card'}
                style={{marginBottom: 15}}
            >
                <View
                    className={'card-body'}
                >
                    <ThemeButton
                        text={TQuestionList[AppConfig.lang].NEW_QUESTION}
                        onPress={addQuestion}
                    />
                </View>
            </View>
        </View>
    );
};

export default QuestionList;